export default __webpack_public_path__ + "static/media/FINAL-ROCKETS-06.795f90ce.svg";